import { RippleGlobalOptions } from '@angular/material/core';

export const globalRippleConfig: RippleGlobalOptions = {
  disabled: false,
  animation: {
    enterDuration: 2.5,
    exitDuration: 2.5,
  }
};
